var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.74 184.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.48,2.41s-21.09,9.37-30.46,4.69S17.58-2.27,10.55,4.76C3.52,11.79,1.17,14.13,1.17,30.53c0,16.4,9.37,39.84,9.37,49.21s-2.34,65.62-2.34,67.96c0,2.34-2.34,32.81,7.03,32.81s7.03-9.37,11.72-23.43,14.06-35.15,14.06-35.15c0,0,2.34-14.06,9.37-14.06,7.03,0,9.37,11.72,9.37,11.72,0,0,4.69,35.15,7.03,42.18s-2.34,21.09,7.03,21.09,16.4-25.78,16.4-32.81c0-7.03,7.03-49.21,4.69-58.59-2.34-9.37-4.69-14.06,0-30.46,4.69-16.4,11.72-35.15,4.69-44.53C92.57,7.1,92.57.07,71.48,2.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.85,72.72s-39.84,4.69-60.93,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.85,21.16s-2.34-4.69-11.72-2.34c-9.37,2.34-18.75,2.34-18.75,7.03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m57.41,11.79s-4.69,2.34-7.03,2.34c-2.34,0,0,9.37-7.03,7.03-7.03-2.34-11.72-4.69-18.75-4.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth19);
export default __webpack_public_path__ + "static/media/tooth-19.d4bab3904629e72e80b7785f8a89bfbb.svg";
export { ForwardRef as ReactComponent };